import { render, staticRenderFns } from "./addAd.vue?vue&type=template&id=56a0e92d&"
import script from "./addAd.vue?vue&type=script&lang=js&"
export * from "./addAd.vue?vue&type=script&lang=js&"
import style0 from "./addAd.vue?vue&type=style&index=0&id=56a0e92d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports